const makeTemplateLocation = (location, locationType) => ({
    location,
    locationType,
});

export default makeTemplateLocation;
